import { api } from '../lib/api';
import type { AuthenticatedUser, LoginResponse } from '../types/api';

export async function login(email: string, password: string): Promise<LoginResponse> {
  const { data } = await api.post<LoginResponse>('/auth/login', { email, password });
  return data;
}

// Validates a stored token on app load and returns fresh role claims -
// avoids trusting a possibly-stale decoded JWT payload for anything
// permission-related.
export async function fetchMe(): Promise<AuthenticatedUser> {
  const { data } = await api.get<AuthenticatedUser>('/auth/me');
  return data;
}
